<!--
 * @Author: your name
 * @Date: 2020-08-27 18:00:06
 * @LastEditTime: 2022-10-27 14:28:03
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/PyLoading/index.vue
-->
<style scoped lang="sass">
.loading_top
  height: 100%
  width: 100%
  position: fixed
  top: 0
  z-index: 2400

  .loading
    height: 100%
    width: 100%
    opacity: .5
    background: #fff
    z-index: 1
    display: flex
    justify-content: center
    align-items: center

::v-deep
  .van-loading
    position: absolute
    top: 50%
    left: 50%
    transform: translate3d(-50%, -50%, 0)

.nav_mask
  position: absolute
  width: 100%
</style>

<style lang="sass" scoped>
.nav_bar
  position: absolute
  display: flex
  align-items: center
  justify-content: space-between
  height: 58px
  width: 100%
  line-height: 58px
  background: var(--menu-header-background-colour)
  color: var(--menu-header-colour)
  z-index: 0

.right,
.left
  display: flex
  justify-content: center
  align-items: center
  height: 60px
  width: 60px

.arrow_left
  height: 45px
  width: 45px
</style>

<template lang="pug">
.loading_top(v-if="showLoading")
  .nav_bar(v-if="hideTop")
    .left
      img.arrow_left(src="@/assets/navPic/arrow_left.png")
    .right
  .loading
  van-loading(v-if="isMobile" :color="color" :size="size")
  div(v-else v-loading="true")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import resizeHandler from 'utils/resizeHandler'

@Component({
  mixins: [resizeHandler], // Method to determine whether it is a mobile terminal   // 判断是不是手机端的方法

  props: {
    showLoading: {
      type: Boolean,
      default: false,
    },

    hideTop: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: '100',
    },
  },

  computed: {
    color() {
      return this.$store.state.app.color.menu_primary_background_colour
    },
  }
})
class PyLoading extends Vue {}

export default PyLoading
</script>
